import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import AuthGate from './components/AuthGate.jsx';
import MacroRegimeSurface from './components/MacroRegimeSurface.jsx';
import SectorTurnDashboardBridge from './components/SectorTurnDashboardBridge.jsx';
import './styles.css';
import './workspaceEditors.css';
import './horse.css';
import './rateRadar.css';
import './macroRegimeSurface.css';
import './productionReadiness.css';
import './auth.css';
import './v409Recovery.css';
import './globalFlowRecovery.css';
import './stockDetailsRecovery.css';
import './ecosystemRecovery.css';
import './birdsEyeRecovery.css';
import './referenceLayout.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthGate>
      <App />
      <MacroRegimeSurface />
      <SectorTurnDashboardBridge />
    </AuthGate>
  </React.StrictMode>,
);

